import { render, staticRenderFns } from "./Column.vue?vue&type=template&id=2b3362e2"
import script from "./Column.vue?vue&type=script&lang=js"
export * from "./Column.vue?vue&type=script&lang=js"
import style1 from "./../css/themes/default/column.scss?vue&type=style&index=1&prod&lang=scss&module=theme_default&external"
import style2 from "./../css/themes/simple/column.scss?vue&type=style&index=2&prod&lang=scss&module=theme_simple&external"




function injectStyles (context) {
  
  this["theme_default"] = (style1.locals || style1)
this["theme_simple"] = (style2.locals || style2)

}

/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports